export default __webpack_public_path__ + "images/fontSize.3f3b6e6.svg";